export default [
    {
      path: '',
      // Relative to /src/views,
      name: 'home',
      view: 'Dashboard'
    },
    {
        path: '/new-patient',
        name: 'NewPatient',
        view: 'NewPatient'
    },
    {
        path: '/edit-patient',
        name: 'EditPatient',
        view: 'EditPatient'
    },
    {
        path: '/list-refers',
        name: 'ListRefers',
        label: 'جدول الإحالات',
        view: 'ListRefers'
    },
    {
        path: '/list-followup/:id?',
        name: 'ListFollowup',
        label: 'جدول المتابعة',
        view: 'ListFollowup'
    },
    {
        path: '/list-patients',
        name: 'ListPatients',
        view: 'ListPatients'
    },
    {
        path: '/list-profiles',
        name: 'قائمة المراجعين',
        view: 'ListProfiles'
    },
    {
        path: '/list-healthdep',
        name: 'إدارة دوائر الصحة',
        view: 'ListHealthDep'
    },
    {
        path: '/list-groups',
        name: 'إدارة مجاميع المستخدمين',
        view: 'ListGroups'
    },
    {
        path: '/list-users',
        name: 'إدارة المستخدمين',
        view: 'ListUsers'
    },
    {
        path: '/list-batch',
        name: 'إدارة الوجبات',
        view: 'ListBatch'
    },
    {
        path: '/new-user',
        name: 'إضافة مستخدم جديد',
        view: 'NewUser'
    },
    {
        path: '/edit-user',
        name: 'تعديل معلومات المستخدم',
        view: 'EditUser'
    },
    {
        path: '/new-action/:id?/:pname?',
        name: 'NewAction',
        view: 'NewAction'
    },
    {
        path: '/list-actions/:id?',
        name: 'ListActions',
        view: 'ListActions'
    },
    {
        path: '/edit-card',
        name: 'تعديل معلومات العينة',
        view: 'EditCard'
    },
    {
        path: '/new-card',
        name: 'إضافة عينة جديدة',
        view: 'NewCard'
    },
    {
        path: '/help',
        name: 'Help',
        view: 'Help'
    },
    {
        path: '/login',
        name: 'Login',
        view: 'login'
    },
    {
        path: '/cardsreport',
        name: 'CardsReport',
        view: 'CardsReport'
    },
    {
        path: '/agereport',
        name: 'AgeReport',
        view: 'AgeReport'
    },
    {
        path: '/checktypereport',
        name: 'CheckTypeReport',
        view: 'CheckTypeReport'
    },
    {
        path: '/resultsreport',
        name: 'ResultsReport',
        view: 'ResultsReport'
    },
    {
        path: '/logout',
        name: 'Logout',
        view: 'Logout'
    }
  ]
